import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";
import { TagType } from "interfaces/tags";

export const filtersDefs: Array<Filter> = [
  {
    name: 'name',
    path: [],
    label: 'Description',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    value: [],
    options: 'subscriptions',
  },
  {
    name: 'customer',
    path: ['customer'],
    label: 'Customer Name',
    matching: FilterMatchingType.ARRAY_INCLUDES_CUSTOMERS_DROPDOWN_LAZY,
    key: 'name',
    value: [],
  },
  {
    name: 'product',
    path: ['product'],
    label: 'Product Name',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    value: [],
    options: 'products',
  },
  {
    name: 'status',
    path: [],
    label: 'Status',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    key: 'status',
    value: [],
    options: 'statusOptions',
  },
  {
    name: 'bookingDate',
    path: ['bookingDate'],
    label: 'Booking Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'startDate',
    label: 'Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'endDate',
    path: ['endDate'],
    label: 'End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'cancelDate',
    label: 'Cancel Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'revRecStartDate',
    label: 'Recognition Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'revRecEndDate',
    label: 'Recognition End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'tags',
    path: ['tags'],
    label: 'Tags',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    isArray: true,
    value: [],
    options: 'tags',
    tagType: TagType.CONTRACT,
  },
  {
    name: 'crmId',
    path: ['crmId'],
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  // Amount filters might come back at any point of time, hence not removing completely
  // {
  //   name: 'amount',
  //   label: 'Amount',
  //   matching: FilterMatchingType.NUMBER_COMPARE,
  //   value: {
  //     compareMethod: CompareMethod.EQ,
  //   },
  // },
  // {
  //   name: 'mrr',
  //   label: 'MRR',
  //   matching: FilterMatchingType.NUMBER_COMPARE,
  //   value: {
  //     compareMethod: CompareMethod.EQ,
  //   },
  // },
  // {
  //   name: 'arr',
  //   label: 'ARR',
  //   matching: FilterMatchingType.NUMBER_COMPARE,
  //   value: {
  //     compareMethod: CompareMethod.EQ,
  //   },
  // },
];